<template>
	<div></div>
</template>

<script>
export default {
	name: 'CreateRouteListHeaders',
	setup() {},
}
</script>

<style lang="scss" scoped></style>
